module.exports = __webpack_public_path__ + "img/switchAccountMiddle.c73c7455.png";